<script lang="ts">
  import { _ } from "svelte-i18n";

  import Button from "$lib/components/Button/Button.svelte";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import ClothingTypeOverlayOption from "./ClothingTypeOverlayOption/ClothingTypeOverlayOption.svelte";
  import { goto } from "$app/navigation";
  import Typography from "$lib/components/Typography/Typography.svelte";
  import Modal from "$lib/components/Modal/Modal.svelte";

  export let showFilterOverlay: boolean = false;

  type Group = {
    title: string;
    subTypes?: string[];
  };

  export let selectedType: string;
  export let typeSelection: Group[] = [];

  const onTypeClick = (type: string) => {
    selectedType = type;
    let url = new URL(window.location.href);
    url.searchParams.set("type", type);
    goto(url.href, { replaceState: true, noScroll: true });
    toggleFilterOverlay();
  };

  const toggleFilterOverlay = () => {
    showFilterOverlay = !showFilterOverlay;
    if (showFilterOverlay) {
      document.querySelector("main").classList.add("filtered");
      window.document.body.classList.add("locked");
    } else {
      document.querySelector("main").classList.remove("filtered");
      window.document.body.classList.remove("locked");
    }
  };
</script>

<style lang="scss">
  .clothing-types {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;

    gap: 1rem;

    &--type-group {
      padding-bottom: 1rem;
      border-bottom: 1px solid $on-surface-30;
    }
  }
  // this class is added to allow the filter toolbar to go over the navigation
  :global(main.filtered) {
    z-index: 999999; //to be above Zendesk opening button
    transform: none !important; // to fix filter layout matching height of page on mobile
  }
  .filter-overlay {
    &--sm-buttons {
      width: 100%;
      padding-right: 16px;
      &:last-child {
        padding-right: 0;
      }
    }

    &--layout {
      background-color: $surface;
      z-index: 999999; //to be above Zendesk opening button
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100vw;
      overflow-y: scroll;
      margin-bottom: 72px;
    }

    &--clear {
      border-top: 0.5px solid $inverse-surface;
      background-color: $surface;
      padding: 16px 16px;
      z-index: 11;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100vw;
      height: 72px;

      &__wrapper {
        background-color: $surface;
        height: 100vh;
      }
      &__buttons {
        display: flex;
      }
    }
  }

  .close-filter {
    background-color: $surface;
    top: 0;
    left: 0;
    z-index: 11;

    &--wrapper {
      display: flex;
      justify-content: flex-end;
      width: 100%;
    }

    &--button {
      background-color: transparent;
      border: none;
      height: 56px;
      padding: 16px 16px;
    }
  }

  :global(.filter-modal) {
    z-index: 999999 !important;
  }
</style>

<Modal
  backgroundColor="var(--on-surface-30)"
  isOpen={showFilterOverlay}
  usePortal
  className="filter-modal"
>
  <div class="filter-overlay--layout">
    <div class="filter-overlay--layout_wrapper">
      <div class="close-filter">
        <div class="close-filter--wrapper">
          <button
            class="close-filter--button"
            on:click={() => {
              toggleFilterOverlay();
            }}
          >
            <Icon icon="close" />
          </button>
        </div>

        <ClothingTypeOverlayOption>
          <div class="clothing-types">
            {#each typeSelection as type, index}
              {#if type.subTypes}
                <span class="clothing-types--type-group">
                  <Typography
                    component="span"
                    variant="button1"
                    theme={"on-surface-30"}
                  >
                    {type.title}
                  </Typography>
                </span>
                {#each type.subTypes as subType, index}
                  <span
                    role="button"
                    tabindex="0"
                    on:click={() => onTypeClick(subType)}
                    on:keydown={() => onTypeClick(subType)}
                  >
                    <Typography
                      component="span"
                      variant="button1"
                      theme={selectedType === subType
                        ? "surface-variant"
                        : "on-surface"}
                    >
                      {subType}
                    </Typography>
                  </span>
                {/each}
              {:else}
                <span
                  role="button"
                  tabindex="0"
                  on:click={() => onTypeClick(type.title)}
                  on:keydown={() => onTypeClick(type.title)}
                >
                  <Typography
                    component="span"
                    variant="button1"
                    theme={selectedType === type.title
                      ? "surface-variant"
                      : "on-surface"}
                  >
                    {type.title}
                  </Typography>
                </span>
              {/if}
            {/each}
          </div>
        </ClothingTypeOverlayOption>
      </div>
    </div>
  </div>
  <div class="filter-overlay--clear__wrapper">
    <div class="filter-overlay--clear">
      <div class="filter-overlay--clear__buttons">
        <div class="filter-overlay--sm-buttons">
          <Button
            label={$_("close")}
            primary
            fullWidth
            padding=""
            on:click={() => {
              toggleFilterOverlay();
            }}
          />
        </div>
      </div>
    </div>
  </div>
</Modal>
